import { render, staticRenderFns } from "./edit-link-modal.vue?vue&type=template&id=a2fbcbec&lang=pug"
import script from "./edit-link-modal.vue?vue&type=script&lang=js"
export * from "./edit-link-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports